// extracted by mini-css-extract-plugin
module.exports = {"personContainer":"styles_personContainer__cZGuz","personHeadshot":"styles_personHeadshot__H3ysg","personUnderline":"styles_personUnderline__LMZ69"};